export default "__VITE_ASSET__BmknpCb0__"